module.exports = __webpack_public_path__ + "img/safe_move03.dcee64b6.png";